var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9013_74255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H5C4.44772 2 4 2.44772 4 3V3.66667C4 4.21895 4.44772 4.66667 5 4.66667H15C15.5523 4.66667 16 4.21895 16 3.66667V3C16 2.44772 15.5523 2 15 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6.6665H3C2.44772 6.6665 2 7.11422 2 7.6665V8.33317C2 8.88546 2.44772 9.33317 3 9.33317H13C13.5523 9.33317 14 8.88546 14 8.33317V7.6665C14 7.11422 13.5523 6.6665 13 6.6665Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.3335H1C0.447715 11.3335 0 11.7812 0 12.3335V13.0002C0 13.5524 0.447715 14.0002 1 14.0002H11C11.5523 14.0002 12 13.5524 12 13.0002V12.3335C12 11.7812 11.5523 11.3335 11 11.3335Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9013_74255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventExplorer);
export default __webpack_public_path__ + "static/media/event-explorer.22426993.svg";
export { ForwardRef as ReactComponent };